import { useNavigation } from "@react-navigation/core";
import React, { useEffect, useState } from "react";
import { ScrollView, Text, TouchableOpacity, View } from "react-native";
import styles from "./styles";
import { FormattedMessage } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import GoBackButton from "../../components/GoBackButton";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { If, Then, Else } from "react-if";

const DepositMethod = () => {
  const navigation = useNavigation();
  const [clientCountry, setClientCountry] = useState("");

  const getClientCountry = async () => {
    const country = await AsyncStorage.getItem("client_country");
    setClientCountry(country);
  };

  useEffect(() => {
    getClientCountry();
  }, []);

  return (
    <View>
      <HeaderTabs
        title={<FormattedMessage id="depositMethod.titleDepositar" />}
        subtitle={
          <Text style={{ fontWeight: "500", marginBottom: 12 }}>
            <FormattedMessage id="depositMethod.escolhaFormaPagamento" />
          </Text>
        }
      />

      <ScrollView>
        <View style={styles.container}>
          <If condition={clientCountry === "brasil"}>
            <Then>
              <TouchableOpacity
                onPress={() => navigation.navigate("DepositGPXAmount")}
                style={styles.listItem}
              >
                <View style={styles.itemTextSection}>
                  <Text style={styles.textBold}>
                    <FormattedMessage id="depositMethod.depositarBrl" />
                  </Text>
                </View>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => navigation.navigate("DepositCryptoSelection")}
                style={styles.listItem}
              >
                <View style={styles.itemTextSection}>
                  <Text style={styles.textBold}>
                    <FormattedMessage id="depositMethod.depositarCriptoativos" />
                  </Text>
                </View>
              </TouchableOpacity>
            </Then>
          </If>
          <TouchableOpacity
            onPress={() => navigation.navigate("PaperWalletDeposit")}
            style={styles.listItem}
          >
            <View style={styles.itemTextSection}>
              <Text style={styles.textBold}>
                <FormattedMessage id="depositMethod.depositarPaperWaller" />
              </Text>
            </View>
          </TouchableOpacity>
          <If condition={clientCountry === "italia"}>
            <Then>
              <TouchableOpacity
                onPress={() => navigation.navigate("StripeCreditCard")}
                style={styles.listItem}
              >
                <View style={styles.itemTextSection}>
                  <Text style={styles.textBold}>
                    <FormattedMessage id="depositMethod.depositarStripeCreditCard" />
                  </Text>
                </View>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => navigation.navigate("DepositBankAccount")}
                style={styles.listItem}
              >
                <View style={styles.itemTextSection}>
                  <Text style={styles.textBold}>
                    <FormattedMessage id="depositBankAccount.btnDepositoBancario" />
                  </Text>
                </View>
              </TouchableOpacity>
            </Then>
          </If>
        </View>
        <View style={{ marginTop: 12 }}>
          <GoBackButton />
        </View>
      </ScrollView>
    </View>
  );
};

export default DepositMethod;
